import styled from 'styled-components';

import {
    MoreVertOutlined as MoreVertOutlinedIcon,
    GetAppOutlined as GetAppOutlinedIcon
} from '@material-ui/icons';

import logoRedesigned from 'images/logoRedesigned.svg';
import {Button} from "@mui/material";

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #fff;
`

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    min-height: 3rem;
    justify-content: space-between;
    padding: 0.75rem 1.5rem;
    background-color: #fff;
    box-sizing: border-box;
    width: 100%;

    @media (min-width: 768px) {
        padding: 1rem 2rem;
    }
`

export const ModalTitle = styled.div`
  color: var(--text-primary, rgba(0, 0, 0, 0.87));
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  letter-spacing: 0.15px;
  flex: 1;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`

export const BackBtn = styled(Button)`
    color: var(--primary-main, #FB7672) !important;
    font-size: 0.875rem !important;
    font-style: normal !important;
    font-weight: 600 !important;
    font-family: inherit !important;
    text-transform: unset !important;
    border-radius: 1rem !important;
    letter-spacing: 0.4px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    background: unset;
    border: unset;
    line-height: inherit;
    padding-left: 8px !important;
    min-width: auto !important;

    &:hover {
        background: unset;
    }

    .arrowIcon {
        height: 1rem;
        margin-right: 0.25rem;
    }
    
    @media (min-width: 768px) {
        font-size: 1rem !important;
        padding-left: 12px !important;
        
        .arrowIcon {
            height: 1.25rem;
        }
    }
`

export const BackButtonContainer = styled.div`
  width: 65px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: var(--primary-main, #FB7672);
`

export const LogoContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: var(--typography-h5-size);
    color: #000;
    font-weight: 600;
    line-height: 123.5%; /* 41.99px */
    letter-spacing: 0.25px;

    @media only screen and (max-width: 600px) {
        font-size: var(--typography-h6-size);
        line-height: 150%; /* 30px */
        letter-spacing: 0.5px;
    }
`

export const LogoImage = styled.img.attrs({
    src: logoRedesigned,
})`
  width: 160px;
  height: 30px;
`

export const AdditionalActionsButton = styled.div`
    display: flex;
    justify-content: flex-end;
    min-width: 40px;
`;

export const StyledMoreVertOutlinedIcon = styled(MoreVertOutlinedIcon)`
  color: #0B4598;
`

export const StyledGetAppOutlinedIcon = styled(GetAppOutlinedIcon)`
  color: #0B4598;
`
